import { toast } from "react-hot-toast";
import { actions } from "utils/helpers";
import { UNAUTHORIZED } from "constants";
import Table from "components/Table/Table";
import { Globals } from "utils/styleconfig";
import { RiFilter3Line } from "react-icons/ri";
import { MdOutlineSort } from "react-icons/md";
import Button from "components/UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthUser } from "features/auth/authSlice";
import Pagination from "components/Pagination/Pagination";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { Fragment, useCallback, useEffect, useState } from "react";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  useGetExtensionsQuery,
  useDeleteExtensionMutation,
} from "features/extension/extensionApiSlice";

import cardStyles from "styles/modules/Card.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";

const Extensions = ({ label }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const authUser = useSelector(selectAuthUser);

  const [searchParams] = useSearchParams();
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  const [toggleModal, setToggleModal] = useState(false);

  const [toggleSort, setToggleSort] = useState(false);

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetExtensionsQuery(searchParams.toString());

  const [deleteExtension] = useDeleteExtensionMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("Extensions"));
  }, [dispatch]);

  useEffect(() => {
    if (isError && !errorDisplayed) {
      toast.error(error?.message || "Could not load extensions, try refreshing the page");
      setErrorDisplayed(true);
    }
  }, [isError, error, errorDisplayed]);


  const onItemClickHandler = (id) => {
    navigate(`/extensions/${id}`);
  };

  // const onEditBtnHandler = useCallback(
  //   (id, callFn = false) => {
  //     if (authUser?.actions[label].includes(actions.view)) {
  //       if (callFn) {
  //         navigate(`/extensions/${id}`);
  //       }

  //       return "";
  //     }

  //     return UNAUTHORIZED;
  //   },
  //   [authUser?.actions, label, navigate]
  // );

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteExtension(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteExtension, label]
  );

  const onSortList = (sortField) => {
    let currentParams = {};

    for (const [key, value] of searchParams.entries()) {
      currentParams[key] = value;
    }

    navigate({
      search: createSearchParams({
        ...currentParams,
        sort_by: sortField,
      }).toString(),
    });
  };

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for extensions</h3>
        <div className={cardStyles.menuOptions}>
          <Button
            onClick={() => setToggleSort((prev) => !prev)}
            className={utilityStyles.outline__button}
          >
            <MdOutlineSort color={Globals.colorDarkBlue} size={17} />
            <span>Sort by</span>
            {toggleSort && (
              <div className={utilityStyles.select__dropdown}>
                <span onClick={() => onSortList("username")}>Username</span>
                <span onClick={() => onSortList("caller_id_number")}>Caller Id Number</span>
              </div>
            )}
          </Button>
        </div>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onItemClickHandler={onItemClickHandler}
            onDelete={onDeleteBtnHandler}
            hiddenColumns={[""]}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default Extensions;
